<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">
        주재원/파견자<br />
        <span class="container_content_list_title_span"
          >대면 / 비대면(실시간 화상)</span
        >
      </div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication15.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #선발/현지문화
              </div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              주재원 사전 역량강화 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            해외 주재원 및 장기 파견자 대상, 성공적인 업무 수행과 현지 정착을
            위한 사전 단계의 모든 솔루션을 제공합니다.
          </div>
          <div class="container_content_text_content">
            해외 파견 전 주재원 선발을 위한 진단과 커뮤니케이션 및 비즈니스 스킬
            향상 등 토탈 교육 진행 목적<br />
            글로벌 업무 수행을 위한 개인의 역량과 현지에서의 문제 상항
            시뮬레이션 훈련 등 진행<br />
            현지 적응기간을 단축하고 현지인과의 갈등을 사전 해결하여 성공적인
            주재원 업무 수행의 기반 마련
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication16.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#파견중지원</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              주재원 파견 중 지원 과정
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            해외 주재원들이 효과적으로 파견 근무에 몰입할 수 있도록 심리, 직무,
            커뮤니케이션에 솔루션을 제공합니다.
          </div>
          <div class="container_content_text_content">
            주재원 현지 적응 문제, 가족 적응 이슈, 해외 법인의 전략적 성과 도출
            등 효율적인 주재원 운영에 전반적인 지원 서비스 제공 목적<br />
            해외 파견 중 겪은 적응 문제에 대한 성과 코칭, 심리 상담 및 안정적
            정착 지원, 커뮤니케이션 어학 교육 등 토탈 솔루션 제공 <br />
            현지 생활에서 필요할 수 있는 모든 서비스 지원 : 전화, 화상외국어,
            심리상담, 코칭 등 맞춤 선택 가능, 회사별 지원 패키지화
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication17.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#정착/DB화</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">주재원 귀임 솔루션</div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            해외 주재원 복귀 후 조직과 개인 생활에 적응하며, 회사의 자산이 될 수
            있도록 다양한 맞춤형 교육을 제공합니다.
          </div>
          <div class="container_content_text_content">
            업무 수행 후 성공적인 조직 복귀 및 귀임 후 주재원 과정 교육 자료로
            활용 가능한 회사의 실질 CASE 개발 도출 목적<br />
            귀임의 심리 지원, 사전 준비사항, 현재 변화된 한국 사회 트렌드 및
            조직 변화 교육, 조직 재적응 프로그램 및 귀임자 경력 개발 계획
            수립<br />
            귀임자와 가족이 겪는 역문화 충격을 최소화하고 안정적으로 정착할 수
            있도록 심리진단 및 코칭 진행, 귀임지식 DB를 위한 워크숍 방식
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: { Contact },
  name: "Dispatch",
};
</script>

<style></style>
